/**
 * This script returns the current active breakpoint
 */
import * as $ from 'jquery';
// @ts-ignore
import * as throttle from 'lodash/throttle';
import '../css/breakpoint-helper.scss';

export type Breakpoint = 'small' | 'medium' | 'large' | 'extra-large';

const classes = {
	helper: 'h-breakpoint__helper',
};

let cachedBreakpoint: Breakpoint;
$(window).on('resize orientationchange', () => {
	cachedBreakpoint = undefined;
});

let lastViewport: Breakpoint;
$(window).on(
	'resize orientationchange',
	throttle(
		() => {
			const newViewport = getCurrentBreakpoint();
			if (lastViewport !== newViewport) {
				lastViewport = newViewport;
				$(window).trigger('uxViewPortChange', [newViewport]);
			}
		},
		25,
		{ leading: true, trailing: true }
	)
);

const $meassureHelper = $(`<div class="${classes.helper}"></div>`);

function meassureBreakpoint() {
	if (!document.body) {
		throw new Error('Document is not ready');
	}
	$meassureHelper.appendTo(document.body);

	return window
		.getComputedStyle($meassureHelper[0], ':before')
		.getPropertyValue('content')
		.replace(/['"]/, '')
		.replace(/['"]/, '') as Breakpoint;
}

/**
 * Register a handler to listen on breakpoint change
 * Passes the current viewport
 *
 * @param handler
 * @returns {()=>JQuery}
 */
export function onBreakpointChange(handler: (viewport?: Breakpoint) => void): () => any {
	const callback = (event: any, viewport: any) => handler(viewport);
	$(window).on('uxViewPortChange', callback);
	return () => $(window).off('uxViewPortChange', callback);
}

/**
 * Returns the current breakpoint using computed style to guarantee matching
 * the css breakpoints
 */
export default function getCurrentBreakpoint(): Breakpoint {
	if (!cachedBreakpoint) {
		cachedBreakpoint = meassureBreakpoint();
	}
	return cachedBreakpoint;
}

export function isSmall(viewport: string): boolean {
	return viewport === 'small';
}

export function isMedium(viewport: string): boolean {
	return viewport === 'medium';
}

export function isLarge(viewport: string): boolean {
	return viewport === 'large';
}

export function isExtraLarge(viewport: string): boolean {
	return viewport === 'extra-large';
}

export function isSmallOrMedium(viewport: string): boolean {
	return isSmall(viewport) || isMedium(viewport);
}
